import crud from './helpers/crud';
import { captureAnalytics } from './preload';
import { normalizeNavPreferences, storeNavPreferences } from '../containers/NewNav/navPreferences';

// One place for every entry point: the nav's corner pencil, right-click, Settings.
export const openNavCustomizer = (source) => (dispatch) => {
  captureAnalytics('nav_customizer_opened', { source });
  dispatch({ type: 'OPEN_NAV_CUSTOMIZER', source });
};

export const closeNavCustomizer = () => (dispatch) => {
  dispatch({ type: 'CLOSE_NAV_CUSTOMIZER' });
};

const setNavPreferences = (preferences) => ({ type: 'SET_NAV_PREFERENCES', preferences });

// There is no client-wide request timeout, and the editor can't be closed while
// a save is in flight, so a stalled save gives up on its own.
export const NAV_PREFERENCES_SAVE_TIMEOUT_MS = 15000;

// Resolves { ok: true } on success, or { ok: false, message }. The message is
// the server's reason for a rejected request (a 4xx, e.g. another tab switched
// orgs, or an unrelated profile field failing validation), or the timeout copy;
// otherwise null and the editor shows its generic retry copy. Saving empty
// lists resets to the default order.
export const saveNavPreferences = ({ order, hidden }) => async (dispatch, getState) => {
  // The org this tab rendered; the server refuses the save if it has changed.
  const organizationId = getState().navCustomization.organizationId;
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), NAV_PREFERENCES_SAVE_TIMEOUT_MS);
  let response;
  try {
    response = await dispatch(crud({
      dispatch: { begin: 'BEGIN_SAVE_NAV_PREFERENCES', end: 'FINISHED_SAVE_NAV_PREFERENCES', fail: 'FAILED_SAVE_NAV_PREFERENCES' },
      method: 'PATCH',
      url: '/api/v1/users',
      data: {
        users: {
          nav_preferences: { order, hidden },
          ...(organizationId ? { nav_preferences_organization_id: organizationId } : {}),
        },
      },
      signal: controller.signal,
    }));
  } finally {
    clearTimeout(timer);
  }
  if (!response || response.canceled) {
    return { ok: false, message: 'Saving your navigation took too long. Please try again.' };
  }
  if (response.error) {
    // crud nests a failure's HTTP response under `response`.
    const status = response.response?.status;
    const rejected = status >= 400 && status < 500;
    return { ok: false, message: (rejected && response.response.data?.error) || null };
  }

  const preferences = normalizeNavPreferences(response.data?.nav_preferences);
  storeNavPreferences(preferences);
  dispatch(setNavPreferences(preferences));
  return { ok: true };
};
